<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Show Comments</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body scrollable-600">
  <ul class="list-unstyled">
    <li class="media" *ngFor="let comment of comments">
      <div class="mr-3">
        <img class="profile-img media-object img-circle" alt="profile"
          [tradxFile]="comment.author === 'customer' && project[comment.author]?.profileImage"
          tradxFileFallback="/assets/imgs/profile_test.png">
      </div>
      <div class="media-body">
        <div class="card">
          <h6 class="media-heading reviews">
              <span class="media-heading reviews">
                {{comment.user.first_name}} {{comment.user.last_name}}
              </span>
            <br>
            {{comment.author === 'customer' ? project[comment.author]?.name : partner?.name}}
          </h6>
          <div class="media-date reviews list-inline">
            <p class="date-body">{{comment.created_at | date:'medium' }}</p>
          </div>
          <p class="text-body">{{comment.title}}</p>
          <p class="media-comment">
            {{comment.text}}
          </p>
          <div *ngIf="comment.attachments?.length">
            Attachments
            <ul>
              <li *ngFor="let attachment of comment.attachments">
                <a [tradxFile]="attachment.realName">
                  {{attachment.displayName}}
                </a>
              </li>
            </ul>
          </div>
          <span class="btn btn-warning btn-circle text-uppercase" *ngIf="comment.replies.length">
              <span class="fa fa-comment"></span> {{comment.replies.length}} replies
            </span>
        </div>
        <ul class="list-unstyled">
          <li class="media media-replied" *ngFor="let reply of comment.replies">
            <div>
              <img class="profile-img media-object img-circle" alt="profile"
                [tradxFile]="project[reply.author]?.profileImage"
                tradxFileFallback="/assets/imgs/profile_test.png">
            </div>
            <div class="media-body">
              <div class="card">
                <h6 class="media-heading reviews">
                    <span class="media-heading reviews">
                      {{reply.user.first_name}} {{reply.user.last_name}}
                    </span>
                  <br>
                  {{reply.author === 'customer' ? project[reply.author]?.name : partner?.name}}
                </h6>
                <div class="media-date text-uppercase reviews list-inline">
                  <p class="date-body">{{reply.created_at | date:'medium' }}</p>
                </div>
                <p class="text-body">{{reply.title}}</p>
                <p class="media-reply">
                  {{reply.text}}
                </p>
                <div *ngIf="reply.attachments?.length">
                  Attachments
                  <ul>
                    <li *ngFor="let attachment of reply.attachments">
                      <a [tradxFile]="attachment.realName">
                        {{attachment.displayName}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
